import React from 'react';
import {
  Box,
  Heading,
  Text,
  Link,
  UnorderedList,
  ListItem,
  Button,
  VStack,
  Divider,
  useColorModeValue,
  Container,
} from '@chakra-ui/react';
import { FaArrowLeft, FaExternalLinkAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const VideoCompressionHelp = () => {
  const navigate = useNavigate();
  const bg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'white');

  return (
    <Container maxW="800px" py={8}>
      <Button 
        leftIcon={<FaArrowLeft />} 
        onClick={() => navigate('/admin-midia')}
        mb={6}
        colorScheme="yellow"
      >
        Voltar para Upload
      </Button>

      <Box bg={bg} p={6} borderRadius="lg" boxShadow="md">
        <Heading as="h1" size="xl" mb={6} color="yellow.500">
          Como Comprimir Vídeos para o Totem
        </Heading>

        <Text fontSize="lg" mb={4} color={textColor}>
          O Supabase (nosso serviço de armazenamento) tem um limite de aproximadamente 50MB para uploads.
          Para vídeos maiores, você precisará comprimi-los antes de fazer o upload.
        </Text>

        <Divider my={6} />

        <Heading as="h2" size="lg" mb={4} color="yellow.500">
          Opção 1: Usar o HandBrake (Recomendado)
        </Heading>

        <VStack align="start" spacing={4} mb={6}>
          <Text color={textColor}>
            HandBrake é um software gratuito e de código aberto para comprimir vídeos:
          </Text>
          <UnorderedList spacing={2} pl={4}>
            <ListItem>1. Baixe e instale o HandBrake em <Link href="https://handbrake.fr/" isExternal color="blue.500">handbrake.fr <FaExternalLinkAlt size="12px" style={{display: 'inline'}} /></Link></ListItem>
            <ListItem>2. Abra o HandBrake e arraste seu vídeo para o programa</ListItem>
            <ListItem>3. Selecione um preset como "Fast 720p30" (bom equilíbrio entre qualidade e tamanho)</ListItem>
            <ListItem>4. Ajuste a qualidade se necessário (quanto menor o valor, menor o arquivo)</ListItem>
            <ListItem>5. Clique em "Start Encode" para gerar o vídeo comprimido</ListItem>
          </UnorderedList>
        </VStack>

        <Divider my={6} />

        <Heading as="h2" size="lg" mb={4} color="yellow.500">
          Opção 2: Usar Serviços Online
        </Heading>

        <VStack align="start" spacing={4} mb={6}>
          <Text color={textColor}>
            Se preferir não instalar software, você pode usar serviços online:
          </Text>
          <UnorderedList spacing={2} pl={4}>
            <ListItem>
              <Link href="https://www.freeconvert.com/video-compressor" isExternal color="blue.500">
                FreeConvert <FaExternalLinkAlt size="12px" style={{display: 'inline'}} />
              </Link> - Compressor de vídeo online gratuito
            </ListItem>
            <ListItem>
              <Link href="https://www.youcompress.com/" isExternal color="blue.500">
                YouCompress <FaExternalLinkAlt size="12px" style={{display: 'inline'}} />
              </Link> - Simples e sem marcas d'água
            </ListItem>
            <ListItem>
              <Link href="https://clideo.com/compress-video" isExternal color="blue.500">
                Clideo <FaExternalLinkAlt size="12px" style={{display: 'inline'}} />
              </Link> - Oferece bom controle sobre a compressão
            </ListItem>
          </UnorderedList>
        </VStack>

        <Divider my={6} />

        <Heading as="h2" size="lg" mb={4} color="yellow.500">
          Dicas para Melhor Compressão
        </Heading>

        <VStack align="start" spacing={3} mb={6}>
          <Text color={textColor}>Para obter o melhor resultado com arquivos pequenos:</Text>
          <UnorderedList spacing={2} pl={4}>
            <ListItem>Reduza a resolução para 720p (1280x720) - suficiente para a maioria dos totens</ListItem>
            <ListItem>Use o codec H.264 para melhor compatibilidade</ListItem>
            <ListItem>Reduza o bitrate para 1500-2500 kbps</ListItem>
            <ListItem>Considere reduzir a taxa de quadros para 24-30 fps</ListItem>
            <ListItem>Remova o áudio se não for necessário</ListItem>
            <ListItem>Corte partes desnecessárias do vídeo</ListItem>
          </UnorderedList>
        </VStack>

        <Box mt={8} textAlign="center">
          <Button 
            colorScheme="yellow" 
            size="lg"
            onClick={() => navigate('/admin-midia')}
          >
            Voltar para Upload de Mídias
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default VideoCompressionHelp;
